import { useCallback, useMemo, useState } from "react";
import {
    getBoardMatById,
    getGrooveStyleForMat,
    loadBoardMatId,
    saveBoardMatHex,
} from "./boardMatPalette";

/**
 * Active puzzle-board mat color + engraved-groove styling derived from brightness.
 */
export function useBoardMatColor() {
    const [matId, setMatIdState] = useState(loadBoardMatId);

    const mat = useMemo(() => getBoardMatById(matId), [matId]);
    const grooveStyle = useMemo(() => getGrooveStyleForMat(mat.hex), [mat.hex]);

    const setMatId = useCallback((id) => {
        const next = getBoardMatById(id);
        setMatIdState(next.id);
        saveBoardMatHex(next.hex);
    }, []);

    return { mat, matId, setMatId, grooveStyle };
}
